import React from "react";

//styles
import "./ShowList.scss";
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

//constants
import { COLORLIST } from "../../../../Constants";
import CommonUtils from "../../../../Utils/CommonUtils";
import { Strings } from "../../../../Resources/Strings/i18n";

//icons
import More from "../../../../Resources/Images/ic_more.png"

class ShowList extends React.Component {

  constructor(props) {
    super(props)
    this.state={ anchorEl: null }
  }
  handleMenuClick = (event) => {
    this.setState({ anchorEl: event.currentTarget })
  }
  handleClose = () => {
    this.setState({ anchorEl: null })
  }
  handleRemove = () => {
    console.log("Attempting to remove connection with ", this.props.user.first_name)
    this.props.handleRemove()
    this.handleClose()
  }

  render() {
    let cardColor = CommonUtils.getColorByIndex(this.props.index, COLORLIST);
    
    return (
      <div
        className="List_Data"
        key={this.props.index}
        style={{
          backgroundColor: cardColor,
        }}
      >
        <div className="leftData">
          <div className="profileImgCard">
            <div className="initialsCard">
              <label>
                {this.props.user.first_name
                  ? this.props.user.first_name.toUpperCase().charAt(0)
                  : null}
                {this.props.user.last_name
                  ? this.props.user.last_name.toUpperCase().charAt(0)
                  : null}
              </label>
            </div>
          </div>
        </div>
        <div className="rightData">
          <div className="profileNameCard">
            {this.props.user.first_name
              ? this.props.user.first_name.toUpperCase()
              : null}{" "}
            {this.props.user.last_name
              ? this.props.user.last_name.toUpperCase()
              : null}
          </div>
          <div className="profileMobileNumber">
            {this.props.user.mobile?this.props.user.mobile:this.props.user.email}
            <Button aria-controls="simple-menu" aria-haspopup="true" onClick={this.handleMenuClick}>
              <img src={More} alt={Strings("More")} />
            </Button>
            <Menu
              id="simple-menu"
              anchorEl={this.state.anchorEl}
              keepMounted
              open={Boolean(this.state.anchorEl)}
              onClose={this.handleClose}
              transformOrigin={{
                horizontal: 'right',
                vertical: 'bottom'
              }}>
              <MenuItem onClick={this.handleRemove}>{Strings("RemoveConnection")}</MenuItem>
            </Menu>
          </div>
          <div className="profileRelation">
            {this.props.user.relation
              ? this.props.user.relation + "-" + this.props.user.status
              : this.props.user.status}
          </div>
        </div>
      </div>
    );
  }
}

export default ShowList;
